/* eslint-disable */
let lazySettings = window.lazy_settings;
let featuredSettings = {};
featuredSettings['templatePath'] = 'online-collections/types/featured-fatalities/fatality.twig';
featuredSettings['variableName'] = 'operation';
var county = '';
var operation = '';
var title = '';
var organisation = '';
var civilwar = false;
var execution = false;
let ajaxTable = document.querySelector('.fatalitiesTable');
//let featuredContainer = document.querySelector('.featuredContainer');
let loadMoreButton = document.querySelector('.js-load-more');
let currentRequest = null,
    notAllDisplayed = true;
let lazyOffset = 1; 

const fatalities = window.fatalities;

console.log(fatalities);

console.log(lazySettings);
    

const ready = (func) => {
  if (document.readyState !== 'loading') {
      func();
  } else {
      document.addEventListener('DOMContentLoaded', func);
  }
};


$(".county-dropdown").on("change", function() {
    county = $(this).val();
    filterTable(organisation, county);
    $('.county-dropdown').val(county);
});

$(".organisation-dropdown").on("change", function() {
    organisation = $(this).val();
    console.log(organisation);
    filterTable(organisation, county);
    $('.organisation-dropdown').val(organisation);
});

$("#fatality").keyup(function() {
    title = $(this).val();
    console.log(title);      
    filterTable(organisation, county, title);      
});
    
function filterTable(organisation, county, title) {
    lazyOffset = 1;
    notAllDisplayed = true;

    $.ajax({
    url: '/table-filter',  // The server endpoint to fetch filtered data
    type: 'GET',
    data: {
        county: county,   
        title: title,
        execution: true,
        organisation: organisation,
        settings: lazySettings,   
    }, // Pass the selected filter
    success: function(response) {
        console.log("empty table");
        console.log(response.data.length);
        if (response.data.length > 29) {
        loadMoreButton.style.display = 'block'; 
        }
        ajaxTable.innerHTML = "";
        let table = '';
        response.data.forEach(item => {
        table += item.html;
        });
        ajaxTable.innerHTML += table;
    },
    error: function(error) {
        console.log("Error fetching filtered data:", error);
    }
    });
}


var oldValue = 0
var newValue = 0

ready(() => {

    $(".js-load-more").click(function() {
        
        if (currentRequest === null && notAllDisplayed === true) {

            loadMoreButton.style.display = 'block';              

            currentRequest = $.ajax({
                url: '/table-load-more',
                method: 'GET',
                data: {
                    offset: lazyOffset,
                    county: county,   
                    organisation: organisation,
                    execution: true,
                    settings: lazySettings,   
                },
                beforeSend: () => {
                    //lazyPreloader.style.display = 'block';
                },
            })
            .always(() => {
                //lazyPreloader.style.display = 'none';
                currentRequest = null;
            })
            .done((returned) => {
                lazyOffset++;
                let html = '';
                returned.data.forEach((element) => {                                            
                    html += element.html;
                });        
                ajaxTable.innerHTML += html;
                if (!returned.data.length) {
                    notAllDisplayed = false;
                    loadMoreButton.style.display = 'none'; 
                }
                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                    return new bootstrap.Tooltip(tooltipTriggerEl)
                })
            })
            .fail(() => {
                errorMessage.textContent = 'Unable to retrieve articles.';
            });
        }
        //oldValue = newValue;


    });
        
    updateTable(fatalities);
    console.log("update");
    
});

function updateTable(fatalities) {
    lazyOffset = 1;
    notAllDisplayed = true;
    $.ajax({
    url: '/table-filter',  // The server endpoint to fetch filtered data
    type: 'GET',
    data: {
        settings: lazySettings,   
    }, // Pass the selected filter
    success: function(response) {
        ajaxTable.innerHTML = "";
        let table = '';
        response.data.forEach(item => {
        table += item.html;
        });
        ajaxTable.innerHTML += table;
        loadMoreButton.style.display = 'block';
    },
    error: function(error) {
        console.log("Error fetching filtered data:", error);
    }
    });
};



/* eslint-enable */